<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <!-- HEADER PART -->
      <v-row>
        <v-col cols="6">
          <div class="d-flex flex-row">
            <h2 class="mb-2 mr-4">{{ $t("Ration Library") }}</h2>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-right">
            <v-btn
              class="mr-2 px-5"
              right
              depressed
              color="primary"
              @click="showPrepareRation = true"
            >
              {{ $t("ration.createRation") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- RATION LIBRARY TABLE STARTS HERE -->
      <div v-if="true">
        <v-card class="my-4" elevation="0">
          <v-card-text class="pa-0">
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab
                class="text-capitalize"
                style="max-width: 400px"
                @click="type = 'individual'"
              >
                {{ $t("ration.suggestedIndividualRation") }}</v-tab
              >
              <v-tab class="text-capitalize" @click="type = 'group'">
                {{ $t("ration.suggestedGroupRation") }}</v-tab
              >
            </v-tabs>
          </v-card-text>
        </v-card>
        <v-card elevation="0">
          <v-card-text>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <!-- :options.sync="options" -->
                <v-data-table
                  v-if="true"
                  :headers="individualRationHeaders"
                  :items="groupRationItems"
                  v-model="selected"
                  :items-per-page="50"
                  :loading="individualListLoading"
                  :loading-text="$t('feedMgt.loadingRationLibraryWait')"
                  hide-default-footer
                  :header-props="{
                    'sort-icon': 'mdi-unfold-more-horizontal',
                  }"
                  :options.sync="inCompleteTableOptions"
                >
                  <template v-slot:top>
                    <div class="d-flex mt-5">
                      <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        height="5px"
                        :placeholder="$t('search')"
                        dense
                        v-model="groupRationSearch"
                        class="shrink"
                        @click="searchGroupRation"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <div class="py-3">
                        {{ groupRationTableOptions.page }} of
                        {{ groupRationTotalPages }}
                      </div>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="groupRationTableOptions.page <= 1"
                        @click="groupRationPageChange(false)"
                      >
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="
                          groupRationTableOptions.page >= groupRationTotalPages
                        "
                        @click="groupRationPageChange(true)"
                      >
                        <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                      <v-menu
                        v-model="individualAnimalMenu"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        left
                        :min-width="417"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> mdi-cog-outline </v-icon>
                          </v-btn>
                        </template>

                        <v-card width="417">
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("farm.customization")
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="pl-3 pt-2 font-weight-normal">
                              {{ $t("farm.recordsPerpage") }}
                            </div>
                            <v-list-item>
                              <v-list-item-content>
                                <v-slider
                                  v-model="individualRationItemsPerPageSlider"
                                  :tick-labels="
                                    individualRationItemsPerPageOptions
                                  "
                                  :max="3"
                                  step="1"
                                  ticks="always"
                                  tick-size="4"
                                ></v-slider>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-n3"></v-divider>
                          </v-list>
                          <v-card-text>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                  class="mt-n9"
                                  cols="6"
                                  v-for="header in headers"
                                  :key="header.value"
                                >
                                  <v-checkbox
                                    v-if="
                                      header.text.length > 0 &&
                                      header.text.toLowerCase() !== 'action'
                                    "
                                    v-model="individualRationSelectedHeaders"
                                    :label="header.text"
                                    color="primary"
                                    :value="header.text"
                                    hide-details
                                    :disabled="
                                      header.text == 'ID' ||
                                      header.text == 'Tag'
                                    "
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-layout justify-center>
                            <v-card-actions class="mb-5">
                              <v-spacer></v-spacer>

                              <v-btn
                                outlined
                                color="primary"
                                width="190"
                                @click="resetIndividualRationDefault"
                              >
                                {{ $t("farm.restoreDefault") }}
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="resetIndividualRationTableStructure"
                              >
                                {{ $t("farm.apply") }}
                              </v-btn>
                            </v-card-actions>
                          </v-layout>
                        </v-card>
                      </v-menu>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        @click="exportToPDF"
                      >
                        <v-img src="/icons/download.svg"></v-img>
                      </v-btn>
                    </div>
                  </template>
                  <template v-slot:progress>
                    <v-progress-linear
                      color="primary"
                      :height="8"
                      indeterminate
                    ></v-progress-linear>
                  </template>

                  <template v-slot:header.cp="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.crudeProtein"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>

                  <template v-slot:header.dm="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.etherExtract"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>

                  <template v-slot:header.tdn="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.totalDigestibleNutrients"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>
                  <template
                    v-if="groupRationItems.length > 0"
                    v-slot:body="{ items }"
                  >
                    <tbody>
                      <tr
                        v-for="item in items"
                        :key="item.farmNumber"
                        style="position: relative; width: 0; height: 0"
                      >
                        <template v-for="h in individualRationHeaders">
                          <td :key="h.text" v-if="h.value == 'status'">
                            <v-btn
                              v-if="item.status_type == 'active'"
                              x-small
                              rounded
                              min-width="120"
                              color="#E5F8F1"
                              depressed
                              class="border-active"
                              height="34"
                            >
                              {{ $t("active") }}
                            </v-btn>
                            <v-btn
                              v-else-if="item.status_type == 'inactive'"
                              x-small
                              rounded
                              min-width="120"
                              color="#FFF0D9"
                              depressed
                              class="border-deactivated"
                              height="34"
                            >
                              {{ $t("inactive") }}
                            </v-btn>
                            <v-btn
                              v-else-if="item.status_type == 'suggested'"
                              x-small
                              rounded
                              min-width="120"
                              color="#E8E8E8"
                              depressed
                              class="border-suggested"
                              height="34"
                            >
                              {{ $t("suggested") }}
                            </v-btn>
                          </td>

                          <td :key="h.value" v-else-if="h.value == 'action'">
                            <div>
                              <v-menu left :offset-x="true" rounded>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on" class="mt-1"
                                    >mdi-dots-vertical
                                  </v-icon>
                                </template>
                                <v-list class="user-menu" style="width: 200px">
                                  <v-list-item
                                    style="padding: 0; cursor: pointer"
                                    @click="editRation(item)"
                                  >
                                    <v-col cols="auto">
                                      <v-btn
                                        x-small
                                        rounded
                                        color="green2"
                                        depressed
                                        fab
                                      >
                                        <v-icon color="green">
                                          mdi-pencil-outline
                                        </v-icon>
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title style="font-size: 14px">
                                      {{ $t("ration.edit") }}</v-list-item-title
                                    >
                                  </v-list-item>
                                  <v-list-item
                                    style="padding: 0; cursor: pointer"
                                    @click="removeRation(item)"
                                  >
                                    <v-col cols="auto">
                                      <v-btn
                                        x-small
                                        rounded
                                        color="red2"
                                        depressed
                                        fab
                                      >
                                        <v-icon color="red">
                                          mdi-trash-can-outline
                                        </v-icon>
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title style="font-size: 14px">
                                      {{
                                        $t("ration.delete")
                                      }}</v-list-item-title
                                    >
                                  </v-list-item>

                                  <v-list-item
                                    v-if="item.status_type == 'active'"
                                    style="padding: 0; cursor: pointer"
                                    @click="
                                      updateRationStatusType(item, 'inactive')
                                    "
                                  >
                                    <v-col cols="auto">
                                      <v-btn x-small rounded depressed fab>
                                        <img
                                          src="/icons/feed_management/inactive-icon.svg"
                                        />
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title
                                      style="font-size: 14px"
                                      >{{
                                        $t("ration.inactive")
                                      }}</v-list-item-title
                                    >
                                  </v-list-item>
                                  <v-list-item
                                    v-else
                                    style="padding: 0; cursor: pointer"
                                    @click="
                                      updateRationStatusType(item, 'active')
                                    "
                                  >
                                    <v-col cols="auto">
                                      <v-btn x-small rounded depressed fab>
                                        <img
                                          src="/icons/feed_management/inactive-icon.svg"
                                        />
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title
                                      style="font-size: 14px"
                                      >{{
                                        $t("ration.useRation")
                                      }}</v-list-item-title
                                    >
                                  </v-list-item>
                                  <v-list-item
                                    style="padding: 0; cursor: pointer"
                                    :disabled="
                                      item.status_type == 'suggested' ||
                                      item.status_type == 'active'
                                    "
                                    @click="repeatRation(item)"
                                  >
                                    <v-col cols="auto">
                                      <v-btn
                                        x-small
                                        rounded
                                        color="red2"
                                        depressed
                                        fab
                                      >
                                        <v-icon color="#E939C2">
                                          mdi-reload
                                        </v-icon>
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title
                                      style="font-size: 14px"
                                      >{{
                                        $t("ration.repeat")
                                      }}</v-list-item-title
                                    >
                                  </v-list-item>

                                  <v-list-item
                                    style="padding: 0; cursor: pointer"
                                    @click="duplicateRation(item)"
                                  >
                                    <v-col cols="auto">
                                      <v-btn
                                        small
                                        rounded
                                        color="warning"
                                        depressed
                                        icon
                                      >
                                        <v-icon size="large">
                                          mdi-content-copy
                                        </v-icon>
                                      </v-btn>
                                    </v-col>

                                    <v-list-item-title
                                      style="font-size: 14px"
                                      >{{
                                        $t("ration.duplicate")
                                      }}</v-list-item-title
                                    >
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </div>
                          </td>
                          <td :key="h.text" v-else-if="h.value == 'createdAt'">
                            {{ item?.createdAt | formatDate }}
                          </td>

                          <td :key="h.value" v-else>
                            {{ item[h.value] }}
                          </td>
                        </template>
                        <div
                          style="position: absolute; right: 10px; top: 4px"
                          v-if="item === selectedItem"
                        ></div>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-tab-item>

              <v-tab-item>
                <v-data-table
                  v-if="true"
                  :headers="groupRationHeaders"
                  :items="groupRationItems"
                  :expanded.sync="expanded"
                  item-key="name"
                  show-expand
                  elevation="0"
                  v-model="selected"
                  :items-per-page="50"
                  :loading="groupListLoading"
                  loading-text="Loading Ration Library... Please wait"
                  hide-default-footer
                  :header-props="{
                    'sort-icon': 'mdi-unfold-more-horizontal',
                  }"
                >
                  <template v-slot:top>
                    <div class="d-flex mt-5">
                      <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        height="5px"
                        placeholder="Search"
                        dense
                        v-model="groupRationSearch"
                        class="shrink"
                        @click="searchGroupRation"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <div class="py-3">
                        {{ groupRationTableOptions.page }} {{ $t("of") }}
                        {{ groupRationTotalPages }}
                      </div>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="groupRationTableOptions.page <= 1"
                        @click="groupRationPageChange(false)"
                      >
                        <v-icon dark> mdi-chevron-left </v-icon>
                      </v-btn>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        :disabled="
                          groupRationTableOptions.page >= groupRationTotalPages
                        "
                        @click="groupRationPageChange(true)"
                      >
                        <v-icon dark> mdi-chevron-right </v-icon>
                      </v-btn>
                      <v-menu
                        v-model="groupRationMenu"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        left
                        :min-width="417"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-2"
                            fab
                            small
                            outlined
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon dark> mdi-cog-outline </v-icon>
                          </v-btn>
                        </template>

                        <v-card width="417">
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  $t("farm.customization")
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="pl-3 pt-2 font-weight-normal">
                              {{ $t("farm.recordsPerpage") }}
                            </div>
                            <v-list-item>
                              <v-list-item-content>
                                <v-slider
                                  v-model="groupRationItemsPerPageSlider"
                                  :tick-labels="groupRationItemsPerPageOptions"
                                  :max="3"
                                  step="1"
                                  ticks="always"
                                  tick-size="4"
                                ></v-slider>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-n3"></v-divider>
                          </v-list>
                          <v-card-text>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                  class="mt-n9"
                                  cols="6"
                                  v-for="header in groupHeaders"
                                  :key="header.value"
                                >
                                  <v-checkbox
                                    v-if="
                                      header.text.length > 0 &&
                                      header.text.toLowerCase() !== 'action'
                                    "
                                    v-model="groupRationSelectedHeaders"
                                    :label="header.text"
                                    color="primary"
                                    :value="header.text"
                                    hide-details
                                    :disabled="
                                      header.text == 'ID' ||
                                      header.text == 'Tag'
                                    "
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-layout justify-center>
                            <v-card-actions class="mb-5">
                              <v-spacer></v-spacer>

                              <v-btn
                                outlined
                                color="primary"
                                width="190"
                                @click="resetGroupRationDefault"
                              >
                                {{ $t("farm.restoreDefault") }}
                              </v-btn>
                              <v-btn
                                color="primary"
                                @click="resetGroupRationTableStructure"
                              >
                                {{ $t("farm.apply") }}
                              </v-btn>
                            </v-card-actions>
                          </v-layout>
                        </v-card>
                      </v-menu>
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="exportToPDF"
                      >
                        <v-img src="/icons/download.svg"></v-img>
                      </v-btn>
                    </div>
                  </template>

                  <template v-slot:progress>
                    <v-progress-linear
                      color="primary"
                      :height="8"
                      indeterminate
                    ></v-progress-linear>
                  </template>

                  <template v-slot:header.cp="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.crudeProtein"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>

                  <template v-slot:header.dm="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.etherExtract"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>

                  <template v-slot:header.tdn="{ header }">
                    <span>
                      {{ header.text }}

                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            style="font-size: 18px"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span
                          >{{
                            $t(
                              "ingredientInventory.mainNutritionalValues.totalDigestibleNutrients"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div>
                      <v-menu left :offset-x="true" rounded>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="mt-1"
                            >mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list class="user-menu" style="width: 200px">
                          <v-list-item
                            style="padding: 0; cursor: pointer"
                            @click="editRation(item)"
                          >
                            <v-col cols="auto">
                              <v-btn
                                x-small
                                rounded
                                color="green2"
                                depressed
                                fab
                              >
                                <v-icon color="green">
                                  mdi-pencil-outline
                                </v-icon>
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px">
                              {{ $t("ration.edit") }}</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            style="padding: 0; cursor: pointer"
                            @click="removeRation(item)"
                          >
                            <v-col cols="auto">
                              <v-btn x-small rounded color="red2" depressed fab>
                                <v-icon color="red">
                                  mdi-trash-can-outline
                                </v-icon>
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px"
                              >Delete</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-if="item.status_type == 'active'"
                            style="padding: 0; cursor: pointer"
                            @click="updateRationStatusType(item, 'inactive')"
                          >
                            <v-col cols="auto">
                              <v-btn x-small rounded depressed fab>
                                <img
                                  src="/icons/feed_management/inactive-icon.svg"
                                />
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px"
                              >Inactive this Ration</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            v-else
                            style="padding: 0; cursor: pointer"
                            @click="updateRationStatusType(item, 'active')"
                          >
                            <v-col cols="auto">
                              <v-btn x-small rounded depressed fab>
                                <img
                                  src="/icons/feed_management/inactive-icon.svg"
                                />
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px"
                              >Use this Ration</v-list-item-title
                            >
                          </v-list-item>

                          <v-list-item
                            style="padding: 0; cursor: pointer"
                            :disabled="
                              item.status_type == 'suggested' ||
                              item.status_type == 'active'
                            "
                            @click="repeatRation(item)"
                          >
                            <v-col cols="auto">
                              <v-btn x-small rounded color="red2" depressed fab>
                                <v-icon color="#E939C2"> mdi-reload </v-icon>
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px"
                              >Repeat</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            style="padding: 0; cursor: pointer"
                            @click="duplicateRation(item)"
                          >
                            <v-col cols="auto">
                              <v-btn
                                small
                                rounded
                                color="warning"
                                depressed
                                icon
                              >
                                <v-icon size="large"> mdi-content-copy </v-icon>
                              </v-btn>
                            </v-col>

                            <v-list-item-title style="font-size: 14px"
                              >Duplicate</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-btn
                      v-if="item.status_type == 'active'"
                      x-small
                      rounded
                      min-width="120"
                      color="#E5F8F1"
                      depressed
                      class="border-active"
                      height="34"
                    >
                      Active
                    </v-btn>
                    <v-btn
                      v-else-if="item.status_type == 'inactive'"
                      x-small
                      rounded
                      min-width="120"
                      color="#FFF0D9"
                      depressed
                      class="border-deactivated"
                      height="34"
                    >
                      Inactive
                    </v-btn>
                    <v-btn
                      v-else-if="item.status_type == 'suggested'"
                      x-small
                      rounded
                      min-width="120"
                      color="#E8E8E8"
                      depressed
                      class="border-suggested"
                      height="34"
                      @click="openRationStatusModal(item)"
                    >
                      Suggested
                    </v-btn></template
                  >
                  <template v-slot:item.createdAt="{ item }">{{
                    item?.createdAt | formatDate
                  }}</template>

                  <template v-slot:item.groupName="{ item }">{{
                    getGroupName(item)
                  }}</template>

                  <template
                    v-slot:expanded-item="{ item }"
                    style="width: 1000px"
                  >
                    <td
                      :colspan="13"
                      class="p-10"
                      style="
                        background: #f8fffd;
                        border: 1.5px solid #00bd73 !important;
                        border-radius: 5px !important;
                      "
                    >
                      <v-card class="my-5" elevation="0">
                        <v-data-table
                          :headers="subGroupHeaders"
                          :items="item.subGroupData"
                          hide-default-footer
                          class="expanded-table"
                          :header-props="{
                            'sort-icon': 'mdi-unfold-more-horizontal',
                          }"
                        >
                          <template v-slot:header.totalCP="{ header }">
                            <span>
                              {{ header.text }}

                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="font-size: 18px"
                                  >
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span
                                  >{{
                                    $t(
                                      "ingredientInventory.mainNutritionalValues.crudeProtein"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </span>
                          </template>

                          <template v-slot:header.totalDM="{ header }">
                            <span>
                              {{ header.text }}

                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="font-size: 18px"
                                  >
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span
                                  >{{
                                    $t(
                                      "ingredientInventory.mainNutritionalValues.etherExtract"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </span>
                          </template>

                          <template v-slot:header.totalTDN="{ header }">
                            <span>
                              {{ header.text }}

                              <v-tooltip top color="black">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="font-size: 18px"
                                  >
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span
                                  >{{
                                    $t(
                                      "ingredientInventory.mainNutritionalValues.totalDigestibleNutrients"
                                    )
                                  }}
                                </span>
                              </v-tooltip>
                            </span>
                          </template>
                          <template v-slot:item.animalDetails="{ item }"
                            ><a
                              style="text-decoration: underline"
                              @click="openAnimalDetailDialog(item)"
                              >View Animal Details</a
                            ></template
                          >
                        </v-data-table>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
        <!-- RATION LIBRARY TABLE ENDS HERE -->

        <!-- INCOMPLETE RATIONS TABLE STARTS HERE-->

        <!-- <v-row class="mt-5">
          <v-col cols="6">
            <div class="d-flex flex-row">
              <h2 class="mb-2 mr-4">{{ $t("feedMgt.incompleteRations") }}</h2>
            </div>
          </v-col>
        </v-row>

        <v-card class="my-5" elevation="0">
          <v-card-text>
            <v-data-table
              v-if="true"
              :headers="incompleteRationHeaders"
              :items="incompleteRationItems"
              v-model="selected"
              :items-per-page="50"
              :loading="incompleteListLoading"
              :loading-text="$t('feedMgt.loadingRationLibraryWait')"
              hide-default-footer
              :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal',
              }"
              @pagination="paginationChanged"
            >
              <template v-slot:top>
                <div class="d-flex mt-5">
                  <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    height="5px"
                    placeholder="Search"
                    dense
                    v-model="incompleteRationSearch"
                    class="shrink"
                    @click="searchIncompleteRation"
                  ></v-text-field>
                  <v-btn
                    :disabled="incompleteRationSearch.length < 1"
                    color="primary"
                    height="40"
                    width="40"
                    max-width="40"
                    outlined
                    class="ml-8"
                    @click="searchIncompleteRation"
                  >
                    <v-icon>mdi-filter-outline</v-icon>
                  </v-btn>

                  <v-spacer></v-spacer>
                  <div class="py-3">
                    {{ inCompleteTableOptions.page }} of
                    {{ incompleteRationTotalPages }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="inCompleteTableOptions.page <= 1"
                    @click="incompletePageChange(false)"
                  >
                    <v-icon dark> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="
                      inCompleteTableOptions.page >= incompleteRationTotalPages
                    "
                    @click="incompletePageChange(true)"
                  >
                    <v-icon dark> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-menu
                    v-model="incompleteMenu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>

                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              $t("farm.customization")
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t("farm.recordsPerpage") }}
                        </div>
                        <v-list-item>
                          <v-list-item-content>
                            <v-slider
                              v-model="itemsPerPageSlider"
                              :tick-labels="itemsPerPageOptions"
                              :max="3"
                              step="1"
                              ticks="always"
                              tick-size="4"
                            ></v-slider>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in incompleteHeaders"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-model="incompleteRationSelectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                                :disabled="
                                  header.text == 'ID' ||
                                  header.text == 'Tag' ||
                                  header.text == '' ||
                                  header.text == 'Ration/Name ID' ||
                                  header.text == 'Status' ||
                                  header.text == 'Action'
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>

                          <v-btn
                            outlined
                            color="primary"
                            width="190"
                            @click="resetIncompleteDefault"
                          >
                            {{ $t("farm.restoreDefault") }}
                          </v-btn>
                          <v-btn
                            color="primary"
                            @click="resetIncompleteTableStructure"
                          >
                            {{ $t("farm.apply") }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    @click="downloadFile('incomplete-ration')"
                  >
                    <v-icon dark>mdi-tray-arrow-down </v-icon>
                  </v-btn>
                </div>
              </template>
              <template v-slot:progress>
                <v-progress-linear
                  color="primary"
                  :height="8"
                  indeterminate
                ></v-progress-linear>
              </template>
              <template v-slot:no-data>{{ $t("noDataAvailable") }}</template>
              <template
                v-if="incompleteRationItems.length > 0"
                v-slot:body="{ items }"
              >
                <tbody>
                  <tr
                    class="my-3"
                    v-for="item in items"
                    :key="item.farmNumber"
                    style="position: relative; width: 0; height: 0"
                  >
                    <template>
                      <td>
                        {{ item.name }}
                      </td>

                      <td>
                        <div
                          class="pa-2 float-right"
                          style="
                            background: #faf5da;
                            border: 1px solid #ffb443;
                            border-radius: 4px;
                            width: fit-content;
                          "
                        >
                          <v-icon>mdi-alert-outline</v-icon> {{ item.status }}
                        </div>
                      </td>
                      <td>
                        <div>
                          <v-menu left :offset-x="true" rounded>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" class="mt-1"
                                >mdi-dots-vertical
                              </v-icon>
                            </template>
                            <v-list class="user-menu" style="width: 200px">
                              <v-list-item
                                style="padding: 0; cursor: pointer"
                                @click="removeRation(item)"
                              >
                                <v-col cols="auto">
                                  <v-btn
                                    x-small
                                    rounded
                                    color="red2"
                                    depressed
                                    fab
                                  >
                                    <v-icon color="red">
                                      mdi-trash-can-outline
                                    </v-icon>
                                  </v-btn>
                                </v-col>

                                <v-list-item-title style="font-size: 14px">{{
                                  $t("delete")
                                }}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card> -->
      </div>

      <!-- NO RATION FOUND STARTS-->
      <div v-else>
        <v-card class="my-4" elevation="0">
          <v-card-text>
            <div
              style="height: 80vh"
              class="d-flex flex-column justify-center align-center"
            >
              <img src="/img/Notes.svg" />
              <h4 class="red--text">{{ $t("noRationFound") }}</h4>
              <p class="text-center pt-4" style="width: 300px">
                {{ $t("feedMgt.createRationAbove") }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
    <prepare-ration-dialog
      v-if="showPrepareRation"
      :dialogI="true"
      @closeDialog="showPrepareRation = false"
    >
    </prepare-ration-dialog>
    <confirm-box
      v-if="deleteRation"
      :dialog="deleteRation"
      :title="$t('warning')"
      :message="$t('dConfirm')"
      :confirmBtnText="$t('delete')"
      :confirmData="itemToDelete"
      @confirm:action="deleteRationConfirmed"
    />
    <repeat-ration
      v-if="isRepeatRation"
      :dialogI="isRepeatRation"
      :title="$t('repeatRation')"
      :message1="'Do you want to Repeat this ' + itemToRepeat.name + '?'"
      :message2="$t('feedMgt.dConfirm')"
      :rationID="itemToRepeat.id"
      :confirmBtnText="feedMgt.acceptAndUse"
      @closeDialog="isRepeatRation = false"
      @repeatRationDialog="repeatRationSuccess"
    />

    <save-ration-dialog
      v-if="rationListStatus"
      :dialogI="rationListStatus"
      :rationLists="currentRationGroup"
      :saveRationType="saveRationType"
      @closeDialog="rationListStatus = false"
      @statusChanged="statusChanged"
    />

    <sub-group-animal-details
      v-if="showSubGroupAnimalDetails"
      :dialogI="showSubGroupAnimalDetails"
      @closeDialog="showSubGroupAnimalDetails = false"
      :subGroups="subGroups"
      :rationAnimalGeneratedSubGroupId="rationAnimalGeneratedSubGroupId"
    >
    </sub-group-animal-details>

    <edit-ration
      v-if="openRationEdit"
      :dialogI="openRationEdit"
      @confirmDialog="confirmRationEdit"
      :ration="selectedRation"
    ></edit-ration>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import PrepareRationDialog from "@/views/feed_management/ration_library/DialogBox/PrepareRationDialog";
// incompleteRation
import { rations, removeRation, duplicateRation } from "@/graphql/Feed.gql";
import ConfirmBox from "@/components/ConfirmBox.vue";
import RationStatusChangeDialog from "@/views/feed_management/ration_library/DialogBox/GroupRationStatusDialog";
import RepeatRation from "@/views/feed_management/ration_library/DialogBox/RepeatRationDialog.vue";
// import DownloadService from "@/_services/DownloadService";
import gql from "graphql-tag";
import html2pdf from "html2pdf.js";
import SubGroupAnimalDetails from "@/views/feed_management/ration_library/DialogBox/SubGroupAnimalDetails";
import EditRation from "./DialogBox/EditRation.vue";

export default {
  apollo: {
    rations: {
      query: rations,
      update: data => console.log(data),
      fetchPolicy: "no-cache",
      variables() {
        return {
          searchRationInput: {
            page: this.groupRationTableOptions.page,
            limit:
              this.type == "group"
                ? this.groupRationTableOptions.limit
                : this.individualRationTableOptions.limit,
            type: this.type,
            searchPhrase: this.groupRationSearch,
          },
        };
      },
      result({ data }) {
        this.groupListLoading = true;
        this.individualListLoading = true;
        if (this.type === "group") {
          let rationData = data.rations?.rows;
          for (let i = 0; i < rationData?.length; i++) {
            rationData[i]["subGroupData"] = [];
            for (let j = 0; j < rationData[i].rationAnimalGroups?.length; j++) {
              rationData[i].subGroupData = [
                ...rationData[i].subGroupData,
                ...rationData[i].rationAnimalGroups[j].subGroup,
              ];
            }
          }
          this.groupRationItems = rationData;
        } else {
          this.groupRationItems = data.rations?.rows;
        }
        console.log(this.groupRationItems);
        this.groupRationTotalPages = data.rations?.totalPages;
        this.groupRationTotal + data.rations?.totalRecord;

        this.groupListLoading = false;
        this.individualListLoading = false;
      },
    },
    // incompleteRation: {
    //   query: incompleteRation,
    //   update: (data) => console.log(data),
    //   fetchPolicy: "no-cache",
    //   variables() {
    //     return {
    //       searchRationInput: {
    //         page: this.inCompleteTableOptions.page,
    //         limit: this.inCompleteTableOptions.limit,
    //         type: this.type,
    //         searchPhrase: this.incompleteRationSearch,
    //       },
    //     };
    //   },
    //   result({ data }) {
    //     this.incompleteRationItems = data.incompleteRation?.rows;
    //     this.incompleteRationTotalPages = data.incompleteRation?.totalPages;
    //     this.incompleteRationRecord = data.incompleteRation?.totalRecord;

    //     this.incompleteListLoading = false;
    //   },
    // },
  },
  components: {
    breadcrumb: Breadcrumb,
    "prepare-ration-dialog": PrepareRationDialog,
    "confirm-box": ConfirmBox,
    "repeat-ration": RepeatRation,
    "save-ration-dialog": RationStatusChangeDialog,
    "sub-group-animal-details": SubGroupAnimalDetails,
    "edit-ration": EditRation,
  },

  methods: {
    openAnimalDetailDialog(item) {
      this.subGroups = [item];
      this.rationAnimalGeneratedSubGroupId = Number(item.id);
      this.showSubGroupAnimalDetails = true;
    },
    openRationStatusModal(item) {
      this.currentRationGroup = item;
      this.saveRationType = "start-using";
      this.rationListStatus = true;
    },
    statusChanged() {
      this.rationListStatus = false;
      this.$notify({
        title: "Success!",
        text: "Ration successfully saved.",
        type: "success",
      });
      this.$apollo.queries.rations.refetch();
    },
    getGroupName(item) {
      if (item.rationAnimalGroups?.length) {
        const groupNameArr = item.rationAnimalGroups.map(
          ration => ration.groupName
        );
        return groupNameArr.join(", ");
      }
      return "";
    },
    async exportToPDF() {
      const element = document.querySelector(".v-data-table__wrapper");
      html2pdf(element, {
        margin: 1,
        filename: "Rationlist.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    // async downloadFile(filename) {
    //   const result = await this.$apollo.query({
    //     query: incompleteRation,
    //     fetchPolicy: "no-cache",
    //     variables: {
    //       searchRationInput: {
    //         searchPhrase: this.incompleteRationSearch,
    //         download: true,
    //       },
    //     },
    //   });
    //   const data = result.data.incompleteRation.rows;
    //   DownloadService.download(data, filename);
    // },
    removeRation(item) {
      this.itemToDelete = item;
      this.deleteRation = true;
    },

    clickEditIndividualRation(id) {
      this.$router.push({
        name: "SelectAnimalIndividual",
        query: { rationId: id },
      });
    },
    updateRationStatusType(item, type) {
      const data = {
        rationId: parseInt(item.id),
        statusType: type,
      };

      this.individualListLoading = true;

      return this.$apollo
        .mutate({
          mutation: gql`
            mutation updateRationStatusType($data: UpdateStatusTypeInput!) {
              updateRationStatusType(updateStatusTypeInput: $data)
            }
          `,
          variables: {
            data,
          },
        })
        .then(({ data }) => {
          if (data.updateRationStatusType) {
            this.$notify({
              title: this.$t("successfullyUpdatedStatus"),
              text: "",
              type: "success",
            });
          }
          this.$apollo.queries.rations.refetch();
          this.individualListLoading = false;
        })
        .catch(async error => {
          console.log(error);
          this.individualListLoading = false;
        });
    },

    repeatRation(item) {
      this.itemToRepeat = item;

      this.isRepeatRation = true;
    },

    repeatRationSuccess() {
      this.$notify({
        title: this.$t("repeatRationSuccessfully"),
        text: "",
        type: "success",
      });
      this.$apollo.queries.rations.refetch();
    },

    deleteRationConfirmed(action, item) {
      if (action) {
        this.startLoading();
        this.$apollo
          .mutate({
            mutation: removeRation,
            variables: {
              id: parseInt(item.id),
            },
          })
          .then(async ({ data }) => {
            if (data.removeRation.success) {
              this.$notify({
                title: "Success!",
                text: this.$t("rationDeletedSuccessfully"),
                type: "success",
              });
              await this.$apollo.queries.rations.refetch();
              // await this.$apollo.queries.incompleteRation.refetch();
            }
            this.stopLoading();
          })
          .catch(e => {
            console.log("arc", e);
            this.stopLoading();
          });
      }
      this.itemToDelete = null;
      this.deleteRation = false;
    },
    // sortRecords(h) {
    //   if (this.options?.sortBy[0] && this.options.sortBy[0] == h.value) {
    //     this.options.sortDesc[0] = !this.options.sortDesc[0];
    //   } else {
    //     this.options.sortBy[0] = h.value;
    //     this.options.sortDesc[0] = false;
    //   }
    // },
    groupRationPageChange(t) {
      this.groupListLoading = true;
      if (t)
        this.groupRationTableOptions.page =
          this.groupRationTableOptions.page + 1;
      else
        this.groupRationTableOptions.page =
          this.groupRationTableOptions.page - 1;
      // this.getData()
    },
    incompletePageChange(t) {
      this.incompleteListLoading = true;
      if (t)
        this.inCompleteTableOptions.page = this.inCompleteTableOptions.page + 1;
      else
        this.inCompleteTableOptions.page = this.inCompleteTableOptions.page - 1;
    },
    paginationChanged() {
      this.incompleteListLoading = true;
      this.$router.replace({ query: { page: this.rationTableOptions.page } });
      this.incompleteListLoading = false;
    },
    // resetIncompleteDefault() {
    //   this.incompleteRationHeaders = this.incompleteHeaders;
    //   this.incompleteRationSelectedHeaders = this.allIncompleteSelectedHeaders;
    //   this.incompleteMenu = false;
    // },
    // resetIncompleteTableStructure() {
    //   this.incompleteRationHeaders = this.incompleteHeaders.filter((header) =>
    //     this.incompleteRationSelectedHeaders.includes(header.text)
    //   );
    //   this.inCompleteTableOptions.limit =
    //     this.itemsPerPageOptions[this.itemsPerPageSlider];
    //   this.incompleteMenu = false;
    // },
    resetGroupRationDefault() {
      this.groupRationHeaders = this.groupHeaders;
      this.groupRationSelectedHeaders = this.allGroupRationSelectedHeaders;
      this.groupRationMenu = false;
    },

    resetIndividualRationDefault() {
      this.individualRationHeaders = this.headers;
      this.individualRationSelectedHeaders =
        this.allIndividualRationSelectedHeaders;
      this.individualRationMenu = false;
    },
    resetGroupRationTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.groupRationHeaders = this.groupHeaders.filter(header =>
        this.groupRationSelectedHeaders.includes(header.text)
      );
      this.groupRationTableOptions.limit =
        this.groupRationItemsPerPageOptions[this.groupRationItemsPerPageSlider];
      this.groupRationMenu = false;

      this.$apollo.queries.ration.refetch();
      // this.stopLoading();
    },

    resetIndividualRationTableStructure() {
      // this.startLoading();
      this.loading = true;
      this.individualRationHeaders = this.headers.filter(header =>
        this.individualRationSelectedHeaders.includes(header.text)
      );
      this.individualRationTableOptions.limit =
        this.individualRationItemsPerPageOptions[
          this.individualRationItemsPerPageSlider
        ];
      this.individualRationMenu = false;
      this.$apollo.queries.rations.refetch();
      // this.stopLoading();
    },
    searchGroupRation() {
      this.groupListLoading = true;
      if (this.groupRationSearch == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
      } else {
        this.groupRationTableOptions.page = 1;
      }

      this.$apollo.queries.ration.refetch();
    },
    // searchIncompleteRation() {
    //   this.incompleteListLoading = true;
    //   if (this.incompleteRationSearch == "") return;
    //   if (this.checkBreakPoints) {
    //     this.tabletTableOptions.page = 1;
    //   } else {
    //     this.inCompleteTableOptions.page = 1;
    //   }
    //   this.$apollo.queries.incompleteRation.refetch();
    // },
    duplicateRation(item) {
      this.startLoading();
      const data = {
        rationId: item.id,
      };
      return this.$apollo
        .mutate({
          mutation: duplicateRation,
          variables: data,
        })
        .then(() => {
          // this.$apollo.queries.rations.refetch();
          // this.$apollo.queries.incompleteRation.refetch();
          this.$notify({
            title: "Success!",
            text: "Ration successfully duplicate!",
            type: "success",
          });
          this.stopLoading();
        })
        .catch(e => Promise.reject(e));
    },

    editRation(item) {
      this.selectedRation = item;
      this.openRationEdit = true;
    },

    confirmRationEdit() {
      this.openRationEdit = false;
      this.selectedRation = null;
    },
  },
  async mounted() {
    document.title = "Ration Library";
    this.individualListLoading = true;
    this.groupListLoading = true;
    this.incompleteListLoading = true;

    // this.incompleteTableHeaders = this.incompleteHeaders;
    // this.incompleteRationSelectedHeaders = this.allIncompleteSelectedHeaders;

    this.groupRationHeaders = this.groupHeaders;
    this.individualRationHeaders = this.headers;
    this.groupRationSelectedHeaders = this.allGroupRationSelectedHeaders;
    this.individualRationSelectedHeaders =
      this.allIndividualRationSelectedHeaders;
  },
  data() {
    return {
      subGroups: null,
      rationAnimalGeneratedSubGroupId: null,
      showSubGroupAnimalDetails: false,
      saveRationType: "start-using",
      currentRationGroup: null,
      rationListStatus: false,
      expanded: [],
      singleExpand: false,
      subGroupHeaders: [
        {
          text: "Sub-Groups Name",
          align: "start",
          value: "subGroupName",
        },
        { text: "# of Animals", value: "subGroupAnimalCount" },
        { text: "CP (kg)", value: "totalCP" },
        { text: "DM (kg)", value: "totalDM" },
        { text: "TDN (kg)", value: "totalTDN" },
        { text: "Cost", value: "totalPrice" },
        { text: "", value: "animalDetails" },
      ],
      dessertss: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%",
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%",
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: "8%",
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: "16%",
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%",
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%",
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: "45%",
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: "22%",
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%",
        },
      ],
      individualListLoading: false,
      groupListLoading: false,
      incompleteListLoading: false,
      itemToDelete: null,
      deleteRation: false,
      itemToRepeat: null,
      isRepeatRation: false,
      rationToRemove: null,
      incompleteRationSearch: "",
      groupRationSearch: "",
      incompleteMenu: false,
      groupRationMenu: false,
      individualAnimalMenu: false,
      rationSelectedHeaders: [],
      allIncompleteSelectedHeaders: ["Ration/Name ID", "Status", "Action"],
      allIndividualRationSelectedHeaders: [
        this.$t("feedMgt.rationNameID"),
        this.$t("nOfAnimals"),
        this.$t("species"),
        "(CP) kg",
        "(DM) kg",
        "(TDN) kg",
        "Cost",
        "Reoccur",
        "Created On",
        "Status",
      ],
      allGroupRationSelectedHeaders: [
        this.$t("feedMgt.rationNameID"),
        this.$t("nOfGroups"),
        this.$t("species"),
        "(CP) kg",
        "(DM) kg",
        "(TDN) kg",
        "Cost",
        "Created On",
        "Reoccur",
        "Status",
      ],
      incompleteRationSelectedHeaders: [],
      groupRationSelectedHeaders: [],
      individualRationSelectedHeaders: [],
      incompleteTableHeaders: [],
      groupRationTableHeaders: [],
      individualRationTableHeaders: [],
      rationTableHeaders: [],
      groupRationTotal: 0,
      groupRationTotalPages: 5,
      incompleteRationTotalPages: 0,
      incompleteRationRecord: 0,
      groupRationRecord: 0,
      tab: 0,
      showPrepareRation: false,
      itemsPerPageSlider: 0,
      rationItemsPerPageSlider: 0,
      groupRationItemsPerPageSlider: 0,
      individualRationItemsPerPageSlider: 0,

      itemsPerPageOptions: [5, 10, 25, 50],
      rationItemsPerPageOptions: [5, 10, 25, 50],
      groupRationItemsPerPageOptions: [5, 10, 25, 50],
      individualRationItemsPerPageOptions: [5, 10, 25, 50],

      to: "",
      from: "",
      totalPages: "",
      search: "",
      selected: [],
      totalfarms: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: { page: 1, limit: 5 },
      rationTableOptions: { page: 1, limit: 2 },
      groupRationTableOptions: { page: 1, limit: 5 },
      individualRationTableOptions: { page: 1, limit: 5 },

      inCompleteTableOptions: { page: 1, limit: 10 },
      loadingText: this.$t("loadingPleaseWait"),
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("Feed Management"),
          disabled: true,
          to: { name: "Feed Management" },
        },
        {
          text: this.$t("Ration Library"),
          disabled: true,
          to: { name: "Ration Library" },
        },
      ],
      incompleteHeaders: [
        {
          text: this.$t("ration.rationName"),
          align: "start",
          value: "name",
          class: "black--text",
        },
        {
          text: this.$t("ration.status"),
          align: "start",
          value: "status",
          class: "black--text",
        },
        {
          text: this.$t("ration.action"),
          align: "start",
          value: "action",
          class: "black--text",
        },
      ],
      groupHeaders: [
        { text: "", value: "data-table-expand", color: "teal" },
        {
          text: this.$t("ration.rationName"),
          align: "start",
          value: "name",
          class: "black--text",
        },
        {
          text: this.$t("ration.groupName"),
          value: "groupName",
          class: "black--text",
        },
        {
          text: this.$t("ration.species"),
          value: "species",
          class: "black--text",
        },
        {
          text: this.$t("ration.cp"),
          value: "cp",
          class: "black--text",
        },
        {
          text: this.$t("ration.dm"),
          value: "dm",
          class: "black--text",
        },
        {
          text: this.$t("ration.tdn"),
          value: "tdn",
          class: "black--text",
        },
        {
          text: this.$t("ration.cost"),
          value: "totalCost",
          class: "black--text",
        },
        {
          text: this.$t("ration.reoccur"),
          value: "reoccur",
          class: "black--text",
        },
        {
          text: this.$t("ration.duration"),
          value: "duration",
          class: "black--text",
        },
        {
          text: this.$t("ration.createdDate"),
          value: "createdAt",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.status"),
          value: "status",
          class: "black--text",
        },

        {
          text: "",
          value: "action",
          align: "right",
          sortable: false,
          class: "black--text",
        },
      ],
      headers: [
        {
          text: this.$t("ration.rationName"),
          align: "start",
          value: "name",
          class: "black--text",
        },
        {
          text: this.$t("ration.noOfAnimals"),
          value: "numberOfAnimals",
          class: "black--text",
        },
        {
          text: this.$t("ration.species"),
          value: "Species",
          class: "black--text",
        },
        {
          text: this.$t("ration.cp"),
          value: "cp",
          class: "black--text",
        },
        {
          text: this.$t("ration.dm"),
          value: "dm",
          class: "black--text",
        },
        {
          text: this.$t("ration.tdn"),
          value: "tdn",
          class: "black--text",
        },
        {
          text: this.$t("ration.cost"),
          value: "totalCost",
          class: "black--text",
        },
        {
          text: this.$t("ration.reoccur"),
          value: "reoccur",
          class: "black--text",
        },
        {
          text: this.$t("ration.duration"),
          value: "duration",
          class: "black--text",
        },
        {
          text: this.$t("ration.creationDate"),
          value: "createdAt",
          class: "black--text",
          sortable: false,
        },
        {
          text: this.$t("ration.status"),
          value: "status",
          class: "black--text",
        },
        {
          text: "",
          value: "action",
          align: "right",
          sortable: false,
          class: "black--text",
        },
      ],
      selectedHeaders: [],
      items: [],
      incompleteRationHeaders: [
        {
          text: this.$t("ration.rationName"),
          align: "start",
          value: "name",
          class: "black--text",
        },

        {
          text: "",
          value: "status",
          class: "black--text",
          sortable: false,
        },

        {
          text: "",
          value: "action",
          align: "end",
          sortable: false,
          class: "black--text",
        },
      ],

      groupRationHeaders: [],
      individualRationHeaders: [],

      incompleteRationItems: [],
      groupRationItems: [],
      type: "individual",
      openRationEdit: false,
      selectedRation: null,
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.table-header {
  background: $secondary2-color;
}

.table-header-span {
  text-transform: uppercase !important;
  color: black !important;
}

.border-active {
  border: 1px solid #00bd73 !important;
}

.border-deactivated {
  border: 1px solid #ffb443 !important;
}

.border-suggested {
  border: 1px solid #1e1e1e !important;
}

.v-data-table
  > .v-data-table__wrapper
  tbody
  tr.v-data-table__expanded__content {
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.expanded-table > .v-data-table__wrapper > table > thead {
  background: #1b1203 !important;
}

.v-data-table-header th {
  white-space: nowrap;
}
</style>
